import React, { useState } from 'react';
import { IconButton, InputAdornment, styled, TextField, Tooltip } from '@mui/material';
import { Done } from '@mui/icons-material';
import { toast } from 'react-toastify';
import Dialog from 'components/dialogs/Dialog';
import ProductsAutoComplete from 'components/autocomplete/ProductsAutoComplete';
import MoneyInput from 'components/masked-input/MoneyInput';
import { addLooseProduct } from 'helpers/budgetItems';
import { Product } from 'types/product';
import { useNewSurgerie } from '../hooks/useNewSurgerie';
import { asInputComponent } from 'components/masked-input/asInputComponent';

const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: 20,
  padding: 10,
});

const Row = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: theme.spacing(2),
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: '1fr',
  },
}));

const AddProductDialog: React.FC<{ onExited(): void }> = ({ onExited }) => {
  const { surgerie, handleChangePackages } = useNewSurgerie();
  const [product, setProduct] = useState<Product | null>(null);
  const [quantity, setQuantity] = useState(1);
  const [unitValue, setUnitValue] = useState(0);

  function handleSave() {
    if (!product) {
      toast.error('Selecione o produto');
      return;
    }

    if (quantity <= 0) {
      toast.error('Informe a quantidade');
      return;
    }

    handleChangePackages(addLooseProduct(surgerie.packages, product, quantity, unitValue));
    onExited();
  }

  return (
    <Dialog
      onExited={onExited}
      title="Adicionar produto"
      maxWidth="sm"
      ComponentActions={
        <Tooltip title="Adicionar">
          <IconButton size="small" color="inherit" onClick={handleSave}>
            <Done />
          </IconButton>
        </Tooltip>
      }
    >
      <Container>
        <ProductsAutoComplete
          label="Produto"
          placeholder="Digite o nome do produto"
          selected={product}
          onSelect={setProduct}
        />

        <Row>
          <TextField
            label={product?.unit ? `Quantidade (${product.unit})` : 'Quantidade'}
            type="number"
            value={quantity || ''}
            onChange={e => setQuantity(Number(e.target.value))}
            slotProps={{ htmlInput: { min: 1 } }}
          />
          <TextField
            label="Valor unitário"
            value={unitValue}
            onChange={e => setUnitValue(Number(e.target.value))}
            slotProps={{
              input: {
                startAdornment: <InputAdornment position="start">R$</InputAdornment>,
                inputComponent: asInputComponent(MoneyInput),
              },
            }}
          />
        </Row>
      </Container>
    </Dialog>
  );
};

export default AddProductDialog;
